import store from '~/store'
import { loadLanguageAsync } from '~/plugins/i18n'

export default async (to, from, next) => {
  await loadLanguageAsync(store.getters['lang/locale'])

  next()
}
